export enum OnyxMapVehicleVariant {
  STATUS = 'status',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
